import React, { useEffect, useState, useRef } from "react";
import AuthService from "../../../AuthService";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SecurityIcon from "@mui/icons-material/Security";
import Chip from "@mui/material/Chip";
import {
  Switch,
  Grid,
  Button,
  Typography,
  TextField,
  FormControlLabel,
  IconButton,
  Box,
} from "@mui/material";
import CommonTitle from "./CommonTitle";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";

const FormUser = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const rfmForm = useRef(null);

  const [users, setUsers] = useState([]);
  const [user, setUser] = useState(blankUser());

  function blankUser() {
    return {
      nome: "",
      username: "",
      password: "",
      email: "",
      ativo: true,
    };
  }

  useEffect(() => {
    handleList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event) => {
    setUser((prevUser) => ({
      ...prevUser,
      [event.target.name]: event.target.value,
    }));
  };

  const handleChecked = (event) => {
    setUser((prevUser) => ({
      ...prevUser,
      [event.target.name]: event.target.checked,
    }));
  };

  const handleSubmit = (event) => {
    const md5 = require("js-md5");
    const updatedUser = { ...user };

    if (updatedUser.oldPass !== updatedUser.password) {
      updatedUser.password = md5(updatedUser.password);
    }

    if (updatedUser.email === "") {
      updatedUser.email = null;
    }

    const service = new AuthService();
    const loggedToken = service.getToken();
    const isLoggedUser = loggedToken === updatedUser.token;

    updatedUser.empresa = null;

    service
      .post("/usuario", updatedUser)
      .then((retorno) => {
        if (isLoggedUser) {
          service.setToken(retorno.token);
        }

        handleList();
        setUser(blankUser());

        enqueueSnackbar(`Usuário '${retorno.username}' salvo com sucesso`, {
          variant: "success",
        });
      })
      .catch((err) => {
        if (err.response === undefined) {
          enqueueSnackbar("Falha ao tentar salvar usuário", {
            variant: "error",
          });
        } else {
          err.response.json().then((elem) => {
            enqueueSnackbar("Falha ao salvar usuário " + elem.errorMessage, {
              variant: "error",
            });
          });
        }
      });
  };

  const handleAlter = (user) => {
    setUser({ ...user, oldPass: user.password });
  };

  const handleList = () => {
    const service = new AuthService();
    service
      .get("/usuario/list")
      .then((retorno) => {
        let usuarios = retorno;
        if (!service.getProfile().admin) {
          usuarios = retorno.filter((u) => u.admin !== true);
        }
        setUsers(usuarios);
      })
      .catch((err) => {
        if (err.response === undefined) {
          enqueueSnackbar("Falha ao tentar listar usuários", {
            variant: "error",
          });
        } else {
          err.response.json().then((elem) => {
            enqueueSnackbar("Falha ao listar usuários " + elem.errorMessage, {
              variant: "error",
            });
          });
        }
      });
  };

  const handleDelete = (userToDelete) => {
    const service = new AuthService();
    service.delete(`/usuario/${userToDelete.id}`).then((retorno) => {
      userToDelete.ativo = retorno.ativo;
      setUsers((prevUsers) => [...prevUsers]); // trigger re-render

      enqueueSnackbar("Usuário inativado com sucesso", {
        variant: "success",
      });
    });
  };

  const handleEditUserAsAdmin = (user) => {
    navigate(`/Usuario/${user.id}`);
  };

  const validaForm = () => {
    const { username, nome, password, email } = user;
    const { admin } = new AuthService().getProfile();

    const isEmpty = (value) => !value || value.trim() === "";

    if (isEmpty(username) || isEmpty(nome) || isEmpty(password)) {
      return true;
    }

    if (!admin && isEmpty(email)) {
      return true;
    }

    return false;
  };

  return (
    <>
      <form ref={rfmForm}>
        <Grid container spacing={2}>
          <CommonTitle title="Dados dos usuários" />

          <Grid
            size={{
              xs: 12,
              sm: 3,
            }}
          >
            <TextField
              sx={{ width: "100%" }}
              variant="outlined"
              label="Nome do usuário"
              name="nome"
              value={user.nome || ""}
              onChange={handleChange}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 3,
            }}
          >
            <TextField
              sx={{ width: "100%" }}
              variant="outlined"
              label="Username"
              name="username"
              value={user.username || ""}
              onChange={handleChange}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 3,
            }}
          >
            <TextField
              sx={{ width: "100%" }}
              variant="outlined"
              label="E-mail"
              name="email"
              value={user.email || ""}
              onChange={handleChange}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 3,
            }}
          >
            <TextField
              sx={{ width: "100%" }}
              variant="outlined"
              label="Senha"
              name="password"
              type="password"
              value={user.password || ""}
              onChange={handleChange}
            />
          </Grid>

          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            style={{
              paddingLeft: "1rem",
              marginTop: "1rem",
            }}
            width="100%"
          >
            <FormControlLabel
              name="ativo"
              control={
                <Switch
                  checked={user.ativo}
                  color="primary"
                  onChange={handleChecked}
                />
              }
              label="Ativo"
            />

            <Button
              color="primary"
              variant="contained"
              disabled={validaForm()}
              onClick={handleSubmit}
              sx={{ minWidth: { xs: "auto", lg: "16rem" } }}
            >
              Salvar usuário
            </Button>
          </Box>

          <CommonTitle title="Usuários cadastrados" />
        </Grid>
      </form>
      <div>
        {users.map((user) => (
          <Box key={user.id} style={{ borderBottom: "1px solid lightgray" }}>
            <Grid container alignItems="center">
              <Grid
                size={{
                  xs: 12,
                  sm: 5,
                }}
              >
                <Box display="flex">
                  <Typography>{user.nome}</Typography>
                  {user.admin && (
                    <Chip
                      size="small"
                      label="admin"
                      color="primary"
                      style={{ marginLeft: "10px" }}
                    />
                  )}
                </Box>
              </Grid>

              <Grid
                size={{
                  xs: 12,
                  sm: 4,
                }}
              >
                <Typography>{user.username}</Typography>
              </Grid>

              <Grid
                size={{
                  xs: 12,
                  sm: 1,
                }}
              >
                <Typography
                  style={{ textTransform: "uppercase" }}
                  color={user.ativo ? "textPrimary" : "error"}
                >
                  {user.ativo ? "ATIVO" : "INATIVO"}
                </Typography>
              </Grid>

              <Grid
                size={{
                  xs: 12,
                  sm: 2,
                }}
              >
                <IconButton onClick={() => handleAlter(user)} size="large">
                  <EditIcon />
                </IconButton>
                <IconButton onClick={() => handleDelete(user)} size="large">
                  <DeleteIcon />
                </IconButton>
                <IconButton
                  onClick={() => handleEditUserAsAdmin(user)}
                  size="large"
                >
                  <SecurityIcon />
                </IconButton>
              </Grid>
            </Grid>
          </Box>
        ))}
      </div>
    </>
  );
};

export default FormUser;
